// Saves the customer's cart + uploaded artwork so an admin can see it (Admin → Saved Carts) and follow up.
import API_BASE from "./apiClient";

const KEY_STORAGE = "circuit_saved_cart_key";

export function getSavedCartKey() {
  try {
    const existing = localStorage.getItem(KEY_STORAGE);
    if (existing) return existing;
  } catch {}
  const random = (window.crypto && window.crypto.randomUUID)
    ? window.crypto.randomUUID().replace(/-/g, "")
    : Date.now() + Math.random().toString(36).slice(2);
  const key = "cart_" + random;
  try { localStorage.setItem(KEY_STORAGE, key); } catch {}
  return key;
}

export async function saveCartForFollowUp({ customer, items, couponCode }) {
  try {
    const res = await fetch(`${API_BASE}/saved-carts`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        cartKey: getSavedCartKey(),
        customer,
        couponCode: couponCode || null,
        items: items.map(item => ({
          productId: item.productId,
          productName: item.productName,
          optionMap: item.optionMap || {},
          optionLabels: item.optionLabels || {},
          displayPrice: item.displayPrice || 0,
          artworkUrl: item.artworkUrl || null,
          artworkName: item.artworkUrl ? (item.artworkName || "Artwork") : null,
        })),
      }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
